import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowRight, Star } from 'lucide-react';
import WaitlistModal from './WaitlistModal';
import { useAppConfig } from '../context/AppContext';

const StickyCTA: React.FC = () => {
  const { hasJoinedWaitlist } = useAppConfig();
  const [isVisible, setIsVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      // Show bar after scrolling down 300px
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [location.pathname]);

  // Don't show on the Wishlist page (destination), Partner form, or if already joined waitlist
  if (location.pathname === '/wishlist' || location.pathname === '/partner-form' || hasJoinedWaitlist) return null;

  const animationClass = isVisible 
    ? "translate-y-0 opacity-100" 
    : "translate-y-full opacity-0 pointer-events-none";

  return (
    <>
      <div className={`fixed bottom-0 left-0 right-0 z-40 bg-white/90 backdrop-blur-xl border-t border-slate-200 py-4 pb-6 sm:pb-4 px-4 md:px-8 shadow-[0_-10px_40px_-15px_rgba(0,0,0,0.1)] transition-all duration-500 ease-out transform ${animationClass}`}>
        <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
          
          {/* Text Section - Hidden on very small screens */}
          <div className="hidden sm:flex items-center gap-3">
            <div className="bg-emerald-100 p-2 rounded-lg text-emerald-600">
              <Star className="h-5 w-5" />
            </div>
            <div>
              <p className="text-slate-900 font-bold text-sm">You're early. That means something.</p>
              <p className="text-slate-500 text-xs font-medium">Help shape Pharmelo for your community.</p>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex items-center gap-6 w-full sm:w-auto justify-between sm:justify-end">

             <button 
               onClick={() => setIsModalOpen(true)}
               className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-3 rounded-xl font-bold text-sm transition-all shadow-lg shadow-emerald-600/20 flex items-center gap-2 transform active:scale-95 whitespace-nowrap"
             >
               Claim Your Spot <ArrowRight className="h-4 w-4" />
             </button>
          </div>
        </div>
      </div>
      
      <WaitlistModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        type="waitlist"
      />
    </>
  );
};

export default StickyCTA;